let api = process.env.REACT_APP_API_URL;

const setHeaders = (user, useAuth, useJSON) => {
  let headerObj = {};

  if (useAuth) {
    headerObj["Authorization"] = 'Bearer ' + user.auth_token
  }

  if (useJSON) {
    headerObj["Content-Type"] = "application/json"
  }

  return headerObj;
}

// ---- FEEDBACK ----
export const submitFeedback = (formData) =>
  fetch(`${api}/contact-us`, {
    method: 'POST',
    headers: setHeaders(null, false, true),
    body: JSON.stringify({
      contact_form: formData
    })
  }).then(res => res.json())

// ---- SESSIONS ----
export const login = (user) =>
  fetch(`${api}/login`, {
    method: 'POST',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      auth: {
        email: user.email,
        password: user.password
      }
    })
  }).then(res => res.json())

export const requestResetPassword = (email) =>
  fetch(`${api}/password_resets`, {
    method: 'POST',
    headers: setHeaders(null, false, true),
    body: JSON.stringify({
      email: email
    })
  }).then(res => res.json())

export const updatePassword = (token, email, newPassword) =>
  fetch(`${api}/password_resets/${token}`, {
    method: 'PUT',
    headers: setHeaders(null, false, true),
    body: JSON.stringify({
      email: email,
      password: newPassword
    })
  }).then(res => res.json())

// ---- ONBOARDING ----
export const twitterRequestToken = () => (
  fetch(`${api}/twitter-request-tokens`, {
    method: 'POST'
  }).then(res => res.json())
)

export const twitterUserDetails = (oauth_token, oauth_verifier) => (
  fetch(`${api}/twitter-user-details`, {
    method: 'POST',
    headers: setHeaders(null, false, true),
    body: JSON.stringify({ oauth_token, oauth_verifier })
  }).then(res => res.json())
)

export const createTwitterMaintainer = (maintainerData) => (
  fetch(`${api}/twitter-maintainers/`, {
    method: 'POST',
    headers: setHeaders(null, false, true),
    body: JSON.stringify({maintainer: maintainerData})
  }).then(res => res.json())
)

export const facebookUserDetails = (facebookCode) => (
  fetch(`${api}/facebook-user-details/${facebookCode}`)
  .then(response => response.json())
)

export const createFacebookMaintainer = (maintainerData) => (
  fetch(`${api}/facebook-maintainers/`, {
    method: 'POST',
    headers: setHeaders(null, false, true),
    body: JSON.stringify({maintainer: maintainerData})
  }).then(res => res.json())
)

export const checkUsername = (username) =>
  fetch(`${api}/usernames/${username}`, {
    method: 'GET',
    headers: setHeaders(null, false, true),
  }).then(res => res.json())

export const createMaintainer = (maintainer) =>
  fetch(`${api}/maintainers/`, {
    method: 'POST',
    headers: setHeaders(null, false, true),
    body: JSON.stringify({
      'maintainer': maintainer
    })
  }).then(res => res.json())

export const getSchools = () =>
  fetch(`${api}/schools/`, {
    method: 'GET',
    headers: setHeaders(null, false, true),
  }).then(res => res.json())

export const searchSchools = (query) =>
  fetch(`${api}/schools/search?search_terms=${query}`, {
    method: 'GET',
    headers: setHeaders(null, false, true),
  }).then(res => res.json())

export const createProfile = (user, profile) =>
  fetch(`${api}/profiles/`, {
    method: 'POST',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      profile: profile
    })
  }).then(res => res.json())

export const getSports = () =>
  fetch(`${api}/sports/`, {
    method: 'GET',
    headers: setHeaders(null, false, true),
  }).then(res => res.json())

export const getSport = (sportID) =>
  fetch(`${api}/sports/${sportID}`, {
    method: 'GET',
    headers: setHeaders(null, false, true)
  }).then(res => res.json())

export const addParticipations = (user, userName,  participations) =>
  fetch(`${api}/profiles/${userName}/participations/batch-create`, {
    method: 'POST',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      participations: participations
    })
  }).then(res => res.json())

// ONBOARDING: Maintainers
export const requestMaintainerAccess = (user, username) =>
  fetch(`${api}/profile_stewardship_requests/`, {
    method: 'POST',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      username: username
    })
  }).then(res => res.json())

export const getInvitationInfo = (token) =>
  fetch(`${api}/profile_stewardship_invitations/${token}`, {
    method: 'GET',
    headers: setHeaders(null, false, true),
  }).then(res => res.json())

export const respondToMaintainerRequest = (token, selectedResponse) =>
  fetch(`${api}/profile_stewardship_requests/${token}/${selectedResponse}`, {
    method: 'POST',
    headers: setHeaders(null, false, true),
  })

export const acceptMaintainerInvite = (maintainerData, token) =>
  fetch(`${api}/profile_stewardship_invitations/${token}/accept`, {
    method: 'POST',
    headers: setHeaders(null, false, true),
    body: JSON.stringify({maintainer: maintainerData})
  })

export const declineMaintainerInvite = (token) =>
  fetch(`${api}/profile_stewardship_invitations/${token}/decline`, {
    method: 'POST',
    headers: setHeaders(null, false, true),
  })

// ---- ADMIN ----
export const adminProfile = (user, profileUsername) =>
  fetch(`${api}/admin/profiles/${profileUsername}`, {
    method: 'GET',
    headers: setHeaders(user, true, true)
  }).then(res => res.json())

export const adminProfiles = (user) =>
  fetch(`${api}/admin/profiles`, {
    method: 'GET',
    headers: setHeaders(user, true, true)
  }).then(res => res.json())

export const suspendProfile = (user, profileUsername) =>
  fetch(`${api}/profiles/${profileUsername}/suspend`, {
    method: 'POST',
    headers: setHeaders(user, true, true)
  }).then(res => res.json())

export const activateProfile = (user, profileUsername) =>
  fetch(`${api}/profiles/${profileUsername}/activate`, {
    method: 'POST',
    headers: setHeaders(user, true, true)
  }).then(res => res.json())

export const giveFreeSubscription = (user, profileUsername) =>
  fetch(`${api}/profiles/${profileUsername}/free-subscription`, {
    method: 'POST',
    headers: setHeaders(user, true, true)
  }).then(res => res.json())

export const deleteProfile = (user, profileUsername) =>
fetch(`${api}/admin/profiles/${profileUsername}`, {
  method: 'DELETE',
  headers: setHeaders(user, true, true)
}).then(res => res.json())

export const adminUsers = (user) =>
  fetch(`${api}/admin/users`, {
    method: 'GET',
    headers: setHeaders(user, true, true)
  }).then(res => res.json())

export const deleteUser = (user, userId) =>
fetch(`${api}/admin/users/${userId}`, {
  method: 'DELETE',
  headers: setHeaders(user, true, true)
}).then(res => res.json())

// ---- BILLING ----
export const submitStripePayment = (user, token, address, taxRate, username, sportQuantity, coupon_id, coupon_type) =>
  fetch(`${api}/billings/${username}`, {
    method: 'POST',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      stripe_token: token,
      tax_rate: taxRate,
      sport_qty: sportQuantity.toString(),
      street_address: address.street,
      city: address.city,
      state: address.state,
      zipcode: address.zip,
      coupon_id: coupon_id,
      coupon_type: coupon_type
    })
  }).then(res => res.json())

export const getTaxRate = (user, zip) =>
  fetch(`${api}/billings/tax/${zip}`, {
    method: 'GET',
    headers: setHeaders(user, true, false)
  }).then(res => res.json())

export const getOneTimeFee = () =>
  fetch(`${api}/billings/one-time-fee`, {
    method: 'GET',
    headers: setHeaders(null, false, false),
  }).then(res => res.json())

export const getCoupon = (user, coupon) =>
  fetch(`${api}/billings/coupon/${coupon}`, {
    method: 'GET',
    headers: setHeaders(user, true, false)
  }).then(res => res.json())

// ---- USER PORTAL ----

// Locker
export const updateParticipation = (user, participation, attributes) =>
  fetch(`${api}/participations/${participation.id}`, {
    method: 'PATCH',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      participation: attributes
    })
  })

export const uploadProfileImage = (user, participationID, file) => {
  const data = new FormData();
  data.append('participation[profile_image]', file)

  return fetch(`${api}/participations/${participationID}`, {
    method: 'PATCH',
    headers: setHeaders(user, true, false),
    body: data
  })
}

export const deletePhoto = (user, photoID) =>
  fetch(`${api}/photos/${photoID}`, {
    method: 'DELETE',
    headers: setHeaders(user, true, true)
  })

export const uploadPhoto = (user, participationID, file) => {
  const data = new FormData();
  data.append('photo[file]', file )

  return fetch(`${api}/participations/${participationID}/photos`, {
    method: 'POST',
    headers: setHeaders(user, true, false),
    body: data
  })
}

export const createSeason = (user, participationID, season) =>
  fetch(`${api}/participations/${participationID}/seasons`, {
    method: 'POST',
    headers: setHeaders(user, true, true),
    body: JSON.stringify(season)
  }).then(res => res.json())

export const createGame = (user, seasonID, game) =>
  fetch(`${api}/seasons/${seasonID}/games`, {
    method: 'POST',
    headers: setHeaders(user, true, true),
    body: JSON.stringify(game)
  }).then(res => res.json())

export const updateGame = (user, gameID, game) =>
  fetch(`${api}/games/${gameID}`, {
    method: 'PUT',
    headers: setHeaders(user, true, true),
    body: JSON.stringify(game)
  }).then(res => res.json())


// Account Settings
export const getProfileLevelAccountInfo = (user, athleteUsername) =>
  fetch(`${api}/profiles/${athleteUsername}/account-level-details`, {
    method: 'GET',
    headers: setHeaders(user, true, true),
  }).then(res => res.json())

export const updateProfile = (user, username, profile) =>
  fetch(`${api}/profiles/${username}/`, {
    method: 'PUT',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      profile: profile
    })
  }).then(res => res.json())

export const updateMaintainerEmails = (user, username, emails) =>
  fetch(`${api}/profiles/${username}/maintainer-emails`, {
    method: 'POST',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      maintainer_emails: emails
    })
  }).then(res => res.json())

export const getBillingInfo = (user, username) =>
  fetch(`${api}/billings/${username}`, {
    method: 'GET',
    headers: setHeaders(user, true, true),
  }).then(res => res.json())

export const cancelSubscription = (user, username) =>
fetch(`${api}/billings/${username}/cancel`, {
  method: 'POST',
  headers: setHeaders(user, true, true),
}).then(res => res.json())

export const updateAuthenticatedUserAccountInfo = (user, newUserData) =>
  fetch(`${api}/me/`, {
    method: 'PUT',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      user: {
        first_name: newUserData.first_name,
        last_name: newUserData.last_name,
        phone_number: newUserData.phone_number
      }
    })
  }).then(res => res.json())

export const getAuthenticatedUserInfo = (user) =>
  fetch(`${api}/me`, {
    method: 'GET',
    headers: setHeaders(user, true, true),
  }).then(res => res.json())

export const updateStripePayment = (user, token, address, username, taxRate) =>
  fetch(`${api}/billings/${username}`, {
    method: 'PUT',
    headers: setHeaders(user, true, true),
    body: JSON.stringify({
      billing: {
        stripe_token: token,
        tax_rate: taxRate,
        street_address: address.street,
        city: address.city,
        state: address.zip
      }
    })
  }).then(res => res.json())

// College Search
export const searchColleges = (user, query) =>
  fetch(`${api}/colleges/search?search_terms=${query}`, {
    method: 'GET',
    headers: setHeaders(user, true, true),
  }).then(res => res.json())

// College Sports
export const getCollegeSportsDivsConfs = (user) =>
  fetch(`${api}/colleges/sports`, {
    method: 'GET',
    headers: setHeaders(user, true, true),
  }).then(res => res.json())

// Coach Search
export const getCollegeCoaches = (user, params) =>
  fetch(`${api}/colleges/coaches/search?college=${params["college"]}&gender=${params["gender"]}&sport=${params["sport"]}&division=${params["division"]}&conference=${params["conference"]}${params["states"].map(state => "&states[]=" + state).join('')}`, {
    method: 'GET',
    headers: setHeaders(user, true, true),
  }).then(res => res.json())

// Coach
export const getCoach = (user, coachId) =>
  fetch(`${api}/colleges/coaches/${coachId}`, {
    method: 'GET',
    headers: setHeaders(user, true, true),
  }).then(res => res.json())

// Update Trial Coach View Count
export const updateTrialCoachViews = (user, username) =>
  fetch(`${api}/profiles/${username}/coach-views`, {
    method: 'POST',
    headers: setHeaders(user, true, true),
  }).then(res => res.json())

// ---- RESOURCE LIBRARY ---
export const getResourceLibraryCategories = (user) =>
  fetch(`${api}/articles/categories`, {
    method: 'GET',
    headers: setHeaders(user, true, true)
  }).then(res => res.json())

export const getResourceLibraryCategory = (user, id) =>
  fetch(`${api}/articles/categories/${id}`, {
    method: 'GET',
    headers: setHeaders(user, true, true)
  }).then(res => res.json())

export const getResourceLibraryArticle = (user, id) =>
  fetch(`${api}/articles/${id}`, {
    method: 'GET',
    headers: setHeaders(user, true, true)
  }).then(res => res.json())

// ---- PUBLIC PROFILE ----
export const getProfile = (username) =>
  fetch(`${api}/profiles/${username}`, {
    method: 'GET',
    headers: setHeaders(null, false, true)
  }).then(res => res.json())

export const getParticipation = (id) =>
  fetch(`${api}/participations/${id}`, {
    method: 'GET',
    headers: setHeaders(null, false, true)
  }).then(res => res.json())



// WEBPACK FOOTER //
// ./src/utils/api.js